import { $modal } from 'ziphy-web-shared/basic/lib/utilities/modals'

import { customActions as customCoreActions } from '@core/src/config/customActions'

import EditPatientModal from '@nedoShared/features/patients/patientController/editPatientModal/EditPatient.modal'

// () => ({onClick, wvAction})
export const customActions = {
  ...customCoreActions,
  HANDLE_ADD_PATIENT: ({ callback }) => ({
    onClick: () => callback(),
  }),
  HANDLE_EDIT_PATIENT: ({ patientId }) => ({
    onClick: () => {
      $modal.add(EditPatientModal, { patientId })
    },
  }),
}
